'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDataUsage = function MdDataUsage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 31.6c3.7 0 7-1.7 9.1-4.3l4.3 2.5c-3 4.2-7.8 6.8-13.4 6.8-9.2 0-16.6-7.4-16.6-16.6 0-8.7 6.5-15.7 15-16.6v5c-5.7 0.8-10 5.7-10 11.6 0 6.5 5.1 11.6 11.6 11.6z m1.6-28.2c8.5 0.9 15 7.9 15 16.6 0 2.4-0.4 4.8-1.4 6.8l-4.3-2.6c0.4-1.3 0.7-2.7 0.7-4.2 0-5.9-4.3-10.8-10-11.6v-5z' })
        )
    );
};

exports.default = MdDataUsage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/data-usage.js
// module id = 1413
// module chunks = 168707334958949